type Callback = (...args: any[]) => void;

class ServiceLocalEvents {
  private events: { [key: string]: Callback[] } = {};

  on(event: string, listener: Callback) {
    if (!this.events[event]) {
      this.events[event] = [];
    }

    this.events[event].push(listener);
  }

  off(event: string, listener: Callback) {
    if (!this.events[event]) return;

    this.events[event] = this.events[event].filter(l => l !== listener);
  }

  emit(event: string, ...args: any[]) {
    if (!this.events[event]) return;
    this.events[event].forEach(listener => listener(...args));
  }
}
export const service_local_events = new ServiceLocalEvents();
